import React from 'react';
import { FormattedMessage } from 'react-intl';

export const SAVE_MODES = {
    EDIT: 'EDIT',
    ADD: 'ADD'  
};

export const ALERT_TYPES = {
    VALIDATION: 'ticket_management.form.error_validation',
    EXCEPTION: 'ticket_management.form.error_exception',
    DUPLICATION: 'ticket_management.form.error_duplication'
};

export const ENTITY_TYPES = {
    CATEGORY: <FormattedMessage id='common.category'/>,
    TICKET: <FormattedMessage id='common.ticket_type'/>,
};

export const  CUSTOM_TYPE_OPTIONS = [ 
    { value:'DATE_INPUT', text: 'Date' },
    { value:'OPTION_LIST', text: 'Option List' },
    { value:'TEXT_BOX', text: 'Text Box' }
];

export const DEFAULT_SELECT =  '- Select -';
export const DEFAULT_DUE_DATE_LIMIT = 30;
export const DEFAULT_EXPIRATION_DATE_LIMIT = 999;
export const DEFAULT_EXPIRATION_DATE = 'Expiration Date';
export const STATUSES = [DEFAULT_SELECT, 'ACTIVE', 'INACTIVE'];
export const PRIORITIES = [DEFAULT_SELECT, 'CRITICAL', 'HIGH', 'MEDIUM', 'LOW'];

export const DEFAULT_WORKFLOW_TYPE = 'defaultProcess';

export const FIELD_TYPES = {
    TEXT_INPUT: 'text',
    CHECKBOX_INPUT: 'checkbox',
    SELECT: 'select',
    LEGEND: 'legend',
    CUSTOM_FIELD: 'custom_fields',
    SPANISH_NAME: 'spanish_name'
};

const REGEXP = {
    CATEGORY: /(^[a-zA-Z0-9]+[a-zA-Z0-9-\s():,]*$)|(^[a-zA-Z0-9]$)/,
    DESCRIPTION: /(^[a-zA-Z0-9]+[a-zA-Z0-9-\s()/:,.']*$)|(^[a-zA-Z0-9]$)/,
    SPANISHTEXT:/^[0-9a-zA-ZáÁéÉíÍóÓúÚñÑ ]*$/
};

// Add/Rename new category configs.
export const CATEGORY_FORM_NAMES = {
    NEW_CATEGORY: 'newCategory',
    SPANISH_NAME: 'spanishName'
};

export const CATEGORY_FORM_FIELDS = [
    {
        label: <FormattedMessage id='ticket_management.form_header.name'/>,
        type: FIELD_TYPES.TEXT_INPUT,
        name: CATEGORY_FORM_NAMES.NEW_CATEGORY,
        validation: {
            regExp:  REGEXP.CATEGORY,
            maxLength: 40
        }
    },
    {
        label: <FormattedMessage id='ticket_management.form_header.spanish_name'/>,
        type: FIELD_TYPES.SPANISH_NAME,
        name: CATEGORY_FORM_NAMES.SPANISH_NAME,
        validation: {
            regExp:  REGEXP.SPANISHTEXT,
            maxLength: 40
        }
    }
];

export const TICKET_TYPE_FORM_NAMES = {
    NAME: 'type',
    WORKFLOW: 'filename',
    DESCRIPTION: 'description',
    STATUS: 'status',
    WORKGROUP: 'workgroup',
    DUE_DATE: 'expDate',
    PERMISSION_NAME: 'permission',
    PRIORITY: 'defaultPriority',
    ALLOW_UPLOAD: 'fileUploadEnabled',
    EMAIL_CONFIG: {
        CREATE: 'create',
        OPEN: 'open',
        COMPLETE: 'complete',
        CANCEL: 'cancel',
        SECURE_INBOX: 'secureInbox'
    },
    CUSTOM_FIELDS: 'custom_fields',
    SPANISH_NAME: 'spanishName'
};

export const TICKET_TYPE_TABLE_FIELDS = {
    NAME: 'type',
    CATEGORY: 'category',
    DESCRIPTION: 'description',
    STATUS: 'status',
    WORKGROUP: 'workgroup',
    DUE_DATE: 'expDate',
    PERMISSION_NAME: 'permission',
    PRIORITY: 'defaultPriority',
};

export const DEFAULT_TICKET_TYPE_FORM_FIELDS = [
    {
        label: <FormattedMessage id='ticket_management.form_header.name'/>,
        type: FIELD_TYPES.TEXT_INPUT,
        name: TICKET_TYPE_FORM_NAMES.NAME,
        validation: {
            regExp:  REGEXP.CATEGORY,
            maxLength: 40
        },
        colSpan: 6,
    },
    {
        label: <FormattedMessage id='ticket_management.form_header.description'/>,
        type: FIELD_TYPES.TEXT_INPUT,
        name: TICKET_TYPE_FORM_NAMES.DESCRIPTION,
        validation: {
            regExp:  REGEXP.DESCRIPTION,
            maxLength: 100
        },
        colSpan: 6,
    },
    {
        label: <FormattedMessage id='ticket_management.form_header.spanish_name'/>,
        type: FIELD_TYPES.SPANISH_NAME,
        name: TICKET_TYPE_FORM_NAMES.SPANISH_NAME,
        validation: {
            regExp:  REGEXP.SPANISHTEXT,
            maxLength: 40
        },
        colSpan: 12,
    },
    {
        label: <FormattedMessage id='ticket_management.form_header.status'/>,
        type: FIELD_TYPES.SELECT,
        name: TICKET_TYPE_FORM_NAMES.STATUS,
        colSpan: 6,
    },
    {
        label: <FormattedMessage id='ticket_management.form_header.workgroup'/>,
        type: FIELD_TYPES.SELECT,
        name: TICKET_TYPE_FORM_NAMES.WORKGROUP,
        colSpan: 6,
    },
    {
        label: <FormattedMessage id='ticket_management.form_header.permission'/>,
        type: FIELD_TYPES.SELECT,
        name: TICKET_TYPE_FORM_NAMES.PERMISSION_NAME,
        colSpan: 6,
    },
    {
        label: <FormattedMessage id='ticket_management.form_header.due_date'/>,
        type: FIELD_TYPES.SELECT,
        name: TICKET_TYPE_FORM_NAMES.DUE_DATE,
        colSpan: 6,
    },
    {
        label: <FormattedMessage id='ticket_management.form_header.priority'/>,
        type: FIELD_TYPES.SELECT,
        name: TICKET_TYPE_FORM_NAMES.PRIORITY,
        colSpan: 12,
    },
    {
        type: FIELD_TYPES.CUSTOM_FIELD,
        name:TICKET_TYPE_FORM_NAMES.CUSTOM_FIELDS,
        colSpan: 12,
    },
    {
        label: <FormattedMessage id='ticket_management.form_header.allow_upload'/>,
        type: FIELD_TYPES.CHECKBOX_INPUT,
        name: TICKET_TYPE_FORM_NAMES.ALLOW_UPLOAD,
        colSpan: 12,
    },
    {
        label: <FormattedMessage id='ticket_management.form_header.email_config.legend'/>,
        type: FIELD_TYPES.LEGEND,
        name:'',
        colSpan: 12,
    },
    {
        label: <FormattedMessage id='ticket_management.form_header.email_config.create'/>,
        type: FIELD_TYPES.CHECKBOX_INPUT,
        name: TICKET_TYPE_FORM_NAMES.EMAIL_CONFIG.CREATE,
        colSpan: 2
    },
    {
        label: <FormattedMessage id='ticket_management.form_header.email_config.open'/>,
        type: FIELD_TYPES.CHECKBOX_INPUT,
        name: TICKET_TYPE_FORM_NAMES.EMAIL_CONFIG.OPEN,
        colSpan: 2
    },
    {
        label: <FormattedMessage id='ticket_management.form_header.email_config.complete'/>,
        type: FIELD_TYPES.CHECKBOX_INPUT,
        name: TICKET_TYPE_FORM_NAMES.EMAIL_CONFIG.COMPLETE,
        colSpan: 2
    },
    {
        label: <FormattedMessage id='ticket_management.form_header.email_config.cancel'/>,
        type: FIELD_TYPES.CHECKBOX_INPUT,
        name: TICKET_TYPE_FORM_NAMES.EMAIL_CONFIG.CANCEL,
        colSpan: 2
    }
];
// Needs to be removed used in TicketType.jsx
export const TICKET_TYPE_TABLE_HEADERS = [
    {
        id: TICKET_TYPE_TABLE_FIELDS.STATUS,
        text: ''
    },
    {
        id: TICKET_TYPE_TABLE_FIELDS.CATEGORY,
        text: <FormattedMessage id='ticket_management.ticketTypes.table.header.ticketCategory'/>
    },
    {
        id: TICKET_TYPE_TABLE_FIELDS.NAME,
        text: <FormattedMessage id='ticket_management.ticketTypes.table.header.ticketType'/>
    },
    {
        id: TICKET_TYPE_TABLE_FIELDS.WORKGROUP,
        text: <FormattedMessage id='ticket_management.form_header.workgroup'/>
    },
    {
        id: TICKET_TYPE_TABLE_FIELDS.DUE_DATE,
        text: <FormattedMessage id='ticket_management.form_header.due_date'/>
    },
    {
        id: TICKET_TYPE_TABLE_FIELDS.PERMISSION_NAME,
        text: <FormattedMessage id='ticket_management.form_header.permission'/>
    },
    {
        id: TICKET_TYPE_TABLE_FIELDS.PRIORITY,
        text: <FormattedMessage id='ticket_management.form_header.priority'/>
    }
];

export const CUSTOM_FIELD_FORM_NAMES = {
    NAME: 'name',
    TYPE:'type',
    LIST:'values',
    DESCRIPTION: 'description'
};

export const DEFAULT_COL_SPAN = 6;

export const TKM_WORKFLOW_VERIFY = 'TKM_WORKFLOW_VERIFY';

export const EXPIRATION_DATE_CONSTANT = 999;